import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-540d665a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mb-x3 xl:mb-x4",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "w-100 mb-x2" }
const _hoisted_3 = { class: "color-grid" }
const _hoisted_4 = { class: "w-30" }
const _hoisted_5 = { class: "w-40" }

import SkeletonLine from '@/shared/spinners/SkeletonLine.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFacetColorsSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SkeletonLine)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7], (skeleton) => {
        return _createElementVNode("li", {
          key: skeleton,
          class: "flex flex-no-wrap items-center gap-x-x1"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SkeletonLine, { class: "h-24" })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(SkeletonLine, { class: "sm:h-11" })
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})